import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  fastHands: {
    id: UpgradeType.FastHands,
    icon: ['lightning', 's_hand'],
    cost: { gold: 75 },
    costGrowthRate: 15,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: -1,
    purchaseLimit: 4,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  sharpDagger: {
    id: UpgradeType.SharpDagger,
    icon: ['dagger1', 'h_u_dagger2'],
    cost: { gold: 5000 },
    costGrowthRate: 2.5,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 20,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  poisonDagger: {
    id: UpgradeType.PoisonDagger,
    icon: ['poison', 'random'],
    cost: { gold: 40000 },
    costGrowthRate: 2.3,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 10,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  blackMamba: {
    id: UpgradeType.BlackMamba,
    icon: ['snake'],
    cost: { gold: 40000 },
    costGrowthRate: 1.5,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 40,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  lingeringToxin: {
    id: UpgradeType.LingeringToxin,
    icon: ['poison', 'clock'],
    cost: { gold: 15000 },
    costGrowthRate: 1.8,
    multiplier: 5, // Initial poison duration in ticks/seconds
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 20,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  smokeBomb: {
    id: UpgradeType.SmokeBomb,
    icon: ['bomb'],
    cost: { gold: 15000 },
    costGrowthRate: 1.6,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 10,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  pickpocket: {
    id: UpgradeType.Pickpocket,
    icon: ['hand', 's_goldNecklace'],
    cost: { gold: 3000 },
    costGrowthRate: 1.4,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  midasTouch: {
    id: UpgradeType.MidasTouch,
    icon: ['hand', 's_goldBar'],
    cost: { gold: 12000 },
    costGrowthRate: 2.1,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
};
